<template>
    <BaseButton
        v-bind="props"
        :class="[
            ghostStyles.ghost_button_override,
            ghostStyles[`color_${props.color}_override`],
            sizesStyles[`size_${props.size}`],
        ]"
    >
        <Icon
            v-if="props.leftIcon"
            :name="props.leftIcon"
            :class="sizesStyles.left_icon"
        />
        <Typography
            v-if="props.label"
            type="label"
            :responsive="false"
            v-bind="labelBindings"
            :class="$style.label_override"
        >
            {{ props.label }}
        </Typography>
        <slot />
    </BaseButton>
</template>

<script lang="ts" setup>
import { type HTMLAttributes } from 'vue'

import { type IconNameType } from '@/components_new/Icon'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'

import BaseButton, { type BaseButtonProps } from './components/BaseButton.vue'
import { useLabelBindings } from './composables/use-label-bindings'
import ghostStyles from './styles/ghost.module.css'
import sizesStyles from './styles/sizes.module.css'

type Props = {
    leftIcon?: IconNameType
    label?: string | number
} & BaseButtonProps &
    /* @vue-ignore */ Omit<HTMLAttributes, 'hidden'>

const props = withDefaults(defineProps<Props>(), {
    type: 'button',
    size: 'm',
    width: 'normal',
    color: 'purple-400',
})

const { labelBindings } = useLabelBindings(props.size)
</script>
<style module>
.label_override {
    line-height: 100%;
}
</style>
